<template>
  <iframe :src="file" frameborder="0" width="100%" height="100%" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "iframe-view",
  props: {
    file: { type: String, default: "" },
  },
});
</script>
